import { useEffect } from 'react';
import { useStore } from '@/contexts/StoreContext';

export function DynamicFavicon() {
  const { store } = useStore();

  useEffect(() => {
    if (!store) return;

    // Update favicon
    if (store.faviconUrl) {
      const link = document.querySelector("link[rel*='icon']") as HTMLLinkElement || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'icon';
      link.href = store.faviconUrl;
      
      if (!document.querySelector("link[rel*='icon']")) {
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    }

    // Update page title
    if (store.name) {
      document.title = store.name;
    }
  }, [store]);

  return null;
}
